module.exports = __webpack_public_path__ + "img/remote.b91f0a99.png";